export default class DashboardCurrencyModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
  }
}
